import sharedLabel from '../../translation'
import type {ILabel} from '../../../../types'

export default {
    ...sharedLabel,
    
    enterEmail: <ILabel>{
        de: 'Bitte geben Sie Ihre E-Mail-Adresse ein.',
        en: 'Please enter your email.',
        es: 'Introduzca su dirección de correo electrónico.',
        fr: 'Saisissez votre email.',
        nl: 'Geef u e-mail in a.u.b.',
        it: 'Inserisci la tua email.',
    },
    enterPassword: <ILabel>{
        de: 'Bitte geben Sie ein gültiges Passwort ein.',
        en: 'Please enter valid password.',
        es: 'Ingrese una contraseña válida.',
        fr: 'Veuillez saisir un mot de passe valide.',
        nl: 'Voer a.u.b. een geldig wachtwoord in.',
        it: 'Inserire password.',
    },
    stayLoggedIn: <ILabel>{
        de: 'Angemeldet bleiben',
        en: 'Remember me',
        es: 'Permanezca conectado',
        fr: 'Rester connecté',
        nl: 'Aangemeld blijven',
        it: 'Rimani connesso',
    },
    login: <ILabel>{
        de: 'Anmelden',
        en: 'Login',
        es: 'Entrar',
        fr: 'Connexion',
        nl: 'Log in',
        it: 'Login',
    },
    or: <ILabel>{
        de: 'Oder',
        en: 'Or',
        es: 'O bien',
        fr: 'Ou',
        nl: 'Of',
        it: 'O',
    },
    
    invalidLogin: <ILabel>{
        de: 'Ungültiger Login, bitte E-Mail-Adresse und Passwort überprüfen',
        en: 'Invalid login, please check email address and password.',
        es: 'Inicio de sesión inválido, por favor compruebe su correo electrónico y su contraseña.',
        fr: 'Connexion invalide, veuillez vérifier votre email et votre mot de passe.',
        nl: 'Ongeldige login, controleer e-mail adres en wachtwoord',
        it: 'Login non valido, controlla l\'indirizzo email e la password.',
    },
    loginSuccessful: <ILabel>{ // todo: inhaltlich bestätigen lassen
        de: 'Sie sind angemeldet',
        en: 'You are logged in',
        es: 'Ha iniciado sesión',
        fr: 'Vous êtes connecté',
        nl: 'U bent ingelogd',
        it: 'Sei loggato',
    },
    welcomeBack: <ILabel>{ // todo: inhaltlich bestätigen lassen
        de: 'Willkommen zurück',
        en: 'Welcome back',
        es: 'Bievenido otra vez',
        fr: 'Bienvenue à nouveau',
        nl: 'Welkom terug',
        it: 'Bentornato',
    },
    forgotPassword: <ILabel>{
        de: 'Passwort vergessen?',
        en: 'Forgot Your Password?',
        es: '&iquest;Ha olvidado la contraseña?',
        fr: 'Mot de passe oublié ?',
        nl: 'Uw wachtwoord vergeten?',
        it: 'Hai dimenticato la Password?',
    },
}